import { UPDATE } from "constants/GlobalFilterTypes";

export function updateGlobalFilter(filter) {
  return {
    type: UPDATE,
    filter,
  };
}
